import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionTimeline = ({ timeline }) => {
  const getStatusIcon = (status) => {
    const icons = {
      initiated: 'Play',
      processing: 'Loader2',
      compliance_review: 'Shield',
      aml_check: 'Search',
      pep_screening: 'UserCheck',
      funds_reserved: 'Lock',
      sent_to_bank: 'Building2',
      in_transit: 'Truck',
      completed: 'CheckCircle',
      failed: 'XCircle',
      cancelled: 'Ban'
    };
    return icons?.[status] || 'Circle';
  };

  const getStatusColor = (status, isCompleted) => {
    if (!isCompleted) return 'text-muted-foreground';
    
    const colors = {
      completed: 'text-success',
      failed: 'text-error',
      cancelled: 'text-gray-500'
    };
    return colors?.[status] || 'text-primary';
  };

  return (
    <div className="space-y-4">
      <h4 className="font-medium text-foreground mb-3">Transaction Timeline</h4>
      <div className="relative">
        {timeline?.map((item, index) => {
          const isLast = index === timeline?.length - 1;
          const isCompleted = item?.completedAt !== null;
          
          return (
            <div key={index} className="relative flex items-start space-x-3 pb-4">
              {/* Timeline Line */}
              {!isLast && (
                <div className="absolute left-4 top-8 w-0.5 h-full bg-border"></div>
              )}
              {/* Status Icon */}
              <div className={`flex-shrink-0 w-8 h-8 rounded-full border-2 flex items-center justify-center ${
                isCompleted 
                  ? 'bg-primary/10 border-primary' :'bg-muted border-border'
              }`}>
                <Icon 
                  name={getStatusIcon(item?.status)} 
                  size={14} 
                  className={getStatusColor(item?.status, isCompleted)}
                />
              </div>
              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <p className={`text-sm font-medium ${
                    isCompleted ? 'text-foreground' : 'text-muted-foreground'
                  }`}>
                    {item?.title}
                  </p>
                  {isCompleted && (
                    <span className="text-xs text-muted-foreground">
                      {new Date(item.completedAt)?.toLocaleString()}
                    </span>
                  )}
                </div>
                
                {item?.description && (
                  <p className="text-xs text-muted-foreground mt-1">
                    {item?.description}
                  </p>
                )}
                
                {item?.details && (
                  <div className="mt-2 text-xs text-muted-foreground">
                    {Object.entries(item?.details)?.map(([key, value]) => (
                      <div key={key} className="flex justify-between">
                        <span className="capitalize">{key?.replace('_', ' ')}:</span>
                        <span>{value}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TransactionTimeline;